// importation des bibliothèques de modules node
import React, {useEffect, useState} from 'react';
import {Button, Card, Form} from 'react-bootstrap';
import {useNavigate, useParams} from 'react-router-dom';

// importation du profil layout wrapper
import StudentProfileLayout from './StudentProfileLayout';

import EleveService from '../../services/EleveService';

const ArchiveStudent = () => {
    const [student, setStudent] = useState(null);
    const {id} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        Promise.all([EleveService.getEleve(id)]).then(([eleveData]) => {
            setStudent(eleveData.data);
        });
    }, [id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const eleveData = new FormData();

            eleveData.append('archived', true);

            // Call the EleveService to delete the student
            await EleveService.updateEleve(id, eleveData);

            // Redirect the user to the list of students
            navigate('/education/eleves');
        } catch (error) {
            console.error(
                "Erreur lors de la l'archivage des informations de l'élève",
                error
            );
        }
    };

    return (
        <StudentProfileLayout>
            {student && (
                <>
                    {/*  Form  */}
                    <Form className="mb-3" onSubmit={handleSubmit}>
                        <Card className="border-0">
                            <Card.Header>
                                <div className="mb-3 mb-lg-0">
                                    <h3 className="mb-0">
                                        Archiver{' '}
                                        <span className="text-uppercase">{student.nom || ''}</span>
                                    </h3>
                                    <p className="mb-0">Archiver le profil de cet élève.</p>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <span className="text-warning h4">Attention</span>
                                <p>
                                    Si vous archivez le profil de cet élève, il n'apparaitra plus
                                    dans la liste des élèves. Il sera possible tout de même de
                                    voir les informations de cet élève dans le menu Ancien élèves.
                                </p>
                                <Button variant="warning" type="submit">
                                    Achiver le profil de l'élève
                                </Button>
                            </Card.Body>
                        </Card>
                    </Form>
                </>
            )}
        </StudentProfileLayout>
    );
};

export default ArchiveStudent;
